import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2UsersDetailResponse {
  user_basic_info: UserBasicInfo;
  user_agent_info: UserAgentInfo;
  subscribe_info: SubscribeInfo;
  article_format_settings: ArticleFormatSettings;
  push_settings: PushSettings;
};
export interface UserBasicInfo {
  user_id: string;
  user_global_id: string;
  name: string;
  email: string;
  gender: string;
  role_status: number;
  app_status: number;
  created_at: string;
  expire_at: string;
};

export interface UserAgentInfo {
  name: string;
  personal_title?: string;
  avatar: string;
  introduction?: string;
};

export interface SubscribeInfo {
  video_subscribe: number;
  article_subscribe: number;
  blog_subscribe: number;
  moments_subscribe: number;
  graphic_subscribe: number;
};

export interface ArticleFormatSettings {
  article_header_copy: string;
  article_drainage_image: string;
}

export interface PushSettings {
  [key: number]: number;
}

export class UserBasicInfoData {
  @Required("User ID cannot be empty")
  @IsString()
  userId: string;

  @Required("User global ID cannot be empty")
  @IsString()
  userGlobalId: string;

  @Required("Name cannot be empty")
  @IsString()
  name: string;

  @Required("Email cannot be empty")
  @IsString()
  email: string;

  @Required("Gender cannot be empty")
  @IsString()
  gender: string;

  @Required("Role status cannot be empty")
  @IsNumber("Role status must be a number")
  roleStatus: number;

  @Required("App status cannot be empty")
  @IsNumber("App status must be a number")
  appStatus: number;

  @Required("Created at cannot be empty")
  @IsString()
  createdAt: string;

  @Required("Expire at cannot be empty")
  @IsString()
  expireAt: string;

  @IsString("Personal title must be a string")
  introduction?: string;
}

export class SubscribeInfoData {
  @Required("Video subscribe cannot be empty")
  @IsNumber("Video subscribe must be a number")
  videoSubscribe: number;

  @Required("Article subscribe cannot be empty")
  @IsNumber("Article subscribe must be a number")
  articleSubscribe: number;

  @Required("Blog subscribe cannot be empty")
  @IsNumber("Blog subscribe must be a number")
  blogSubscribe: number;

  @Required("Moments subscribe cannot be empty")
  @IsNumber("Moments subscribe must be a number")
  momentsSubscribe: number;

  @Required("Graphic subscribe cannot be empty")
  @IsNumber("Graphic subscribe must be a number")
  graphicSubscribe: number;

  @Required("AI subscribe cannot be empty")
  @IsNumber("AI subscribe must be a number")
  aiSubscribe: number;

  @Required("Chat subscribe cannot be empty")
  @IsNumber("Chat subscribe must be a number")
  chatSubscribe: number;
}


export class UserAgentInfoData {
  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Avatar cannot be empty")
  @IsString("Avatar must be a string")
  avatar: string;

  @IsString("Personal title must be a string")
  personalTitle?: string;

  @IsString("Personal title must be a string")
  introduction?: string;
}

export class ArticleFormatSettingsData {
  @IsString("Article header copy must be a string")
  articleHeaderCopy: string;

  @IsString("Article drainage image must be a string")
  articleDrainageImage: string;
}

export class AgentV2UsersDetailData {
  @Required("User basic info cannot be empty")
  userBasicInfo: UserBasicInfoData;

  @Required("User agent info cannot be empty")
  userAgentInfo: UserAgentInfoData;

  @Required("Subscribe info cannot be empty")
  subscribeInfo: SubscribeInfoData;

  // @Required("Article format settings cannot be empty")
  articleFormatSettings: ArticleFormatSettingsData;

  @Required("Push settings cannot be empty")
  pushSettings: PushSettings;
}

const transformAndValidateAgent = (
  response: AgentV2UsersDetailResponse
): AgentV2UsersDetailData => {
  const transformedData = transformKeys(response);

  try {
    const data = DataValidator.validateOrThrow(transformedData, AgentV2UsersDetailData);
    if (data.userAgentInfo && !data.userAgentInfo.introduction) {
      data.userAgentInfo.introduction = '';
    }
    if (!data.articleFormatSettings) {
      data.articleFormatSettings = {
        articleHeaderCopy: '',
        articleDrainageImage: '',
      }
    }
    return data;
  } catch (error) {
    console.error("Agent V2 User data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 用户详情 */
export const agentV2UsersDetail = async ({ agentId, userId }: { agentId: string, userId: string }): Promise<AgentV2UsersDetailData> => {
  const response = await api.post<AgentV2UsersDetailResponse>('/agent-v2/users/detail', {
    agent_id: agentId,
    user_id: userId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
